import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--gap);
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: var(--gap);
  margin: 16px 0;
`;

export const Indent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 42px;
  gap: var(--gap);
`;
